"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.COW_DragonWhelp_CauterizeAbilityHandler = exports.COW_DragonWhelp_CauterizeActorAbilityFactory = exports.COW_DragonWhelp_CauterizeAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
class COW_DragonWhelp_CauterizeAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.COW_DragonWhelp_Cauterize;
        this.__typeName = "COW_DragonWhelp_Cauterize";
    }
}
exports.COW_DragonWhelp_CauterizeAbilityArgs = COW_DragonWhelp_CauterizeAbilityArgs;
let COW_DragonWhelp_CauterizeActorAbilityFactory = class COW_DragonWhelp_CauterizeActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("COW_DragonWhelp_Cauterize", "OneAllies", 1);
    }
};
COW_DragonWhelp_CauterizeActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("COW_DragonWhelp_Cauterize")
], COW_DragonWhelp_CauterizeActorAbilityFactory);
exports.COW_DragonWhelp_CauterizeActorAbilityFactory = COW_DragonWhelp_CauterizeActorAbilityFactory;
let COW_DragonWhelp_CauterizeAbilityHandler = class COW_DragonWhelp_CauterizeAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [targetId] = ability.args.target.actorIds;
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                container.applyHealing({
                    sequence,
                    healerId: ability.invokerId,
                    targetId,
                    amount: container.getPercentOfMaxHealth(targetId, 25)
                });
            }
        });
    }
};
COW_DragonWhelp_CauterizeAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.COW_DragonWhelp_Cauterize)
], COW_DragonWhelp_CauterizeAbilityHandler);
exports.COW_DragonWhelp_CauterizeAbilityHandler = COW_DragonWhelp_CauterizeAbilityHandler;
